import { VALIDATION_SCHEMAS } from '../schemes';
import {
  GetUserSettingsServicePayload,
  RequestPromiseProps,
  UserSetting,
} from '../types';

import parseSettings from './parseSettings';

const onParseUserSettings = (
  reject: RequestPromiseProps['reject'],
  {
    settings,
    payload: { name, format },
  }: { settings: UserSetting[]; payload: GetUserSettingsServicePayload },
) => {
  const currentSetting = settings.find((setting) => setting.name === name);

  if (!currentSetting || currentSetting.value === null) {
    const error = new Error(`No ${name} found in user settings`);

    reject(error);
    console.info('getUserSettingsService', error);
  }

  let result;

  try {
    const parsedResult = parseSettings(
      currentSetting as UserSetting<string>,
      format,
    );
    const dataBySchema = {
      name,
      value: parsedResult,
    };

    VALIDATION_SCHEMAS[name as string].validateSync(dataBySchema);

    result = parsedResult;
  } catch (error) {
    console.info('getUserSettingsService', name, error);
    reject(error);
  }

  return result;
};

export default onParseUserSettings;
